import { useContext, useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import Socials from "./Socials";
import leoLogo from "../img/header/leo-logo.png";
import MobileNav from "./MobileNav";
import { CursorContext } from "../context/CursorContext";
import { ScrollLink } from "../components/ScrollLink";

const Header = () => {
  // 🧩 Access mouse hover handlers from global CursorContext
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(CursorContext);

  // 🧩 State for controlling sticky header background
  const [isActive, setIsActive] = useState(false);

  // 🧩 Theme state: "light" or "dark"
  const [theme, setTheme] = useState("dark");

  useEffect(() => {
    // 🧩 Add scroll listener to toggle background color after scrolling
    window.addEventListener("scroll", () => {
      window.scrollY > 300 ? setIsActive(true) : setIsActive(false);
    });
  }, []);

  useEffect(() => {
    // 🧩 Initialize theme to dark if not set
    if (localStorage.getItem("theme") === null) {
      localStorage.setItem("theme", "dark");
    }
  }, []);

  useEffect(() => {
    // 🧩 Sync theme to <html> element for Tailwind dark mode support
    const html = document.querySelector("html");
    if (localStorage.getItem("theme") === "dark") {
      html.classList.add("dark");
      setTheme("dark");
    } else {
      html.classList.remove("dark");
      setTheme("light");
    }
  }, [theme]);

  // 🧩 Toggle theme on button click
  const handleThemeSwitch = () => {
    if (localStorage.getItem("theme") === "light") {
      setTheme("dark");
      localStorage.setItem("theme", "dark");
    } else {
      setTheme("light");
      localStorage.setItem("theme", "light");
    }
  };

  return (
    // 🧩 Header container with dynamic background on scroll
    <header
      className={`${
        isActive ? "bg-beige dark:bg-mate" : "header-wrap"
      } fixed w-full px-[30px] lg:px-[100px] z-30 h-[100px] lg:h-[140px] flex items-center`}
    >
      {/* 🧩 Left: Logo and Nav */}
      <div className="flex flex-col lg:flex-row lg:items-center w-full justify-between">
        {/* 🧩 Logo block with cursor hover animation */}
        <ScrollLink className="max-w-[200px]" section="home">
          <div
            className="logo-wrap"
            onMouseEnter={mouseEnterHandler}
            onMouseLeave={mouseLeaveHandler}
          >
            <img src={leoLogo} alt="" className="logo" />
          </div>
        </ScrollLink>

        {/* 🧩 Desktop navigation with ScrollLink and RouterLink */}
        <nav
          className="hidden xl:flex gap-x-12 font-semibold"
          onMouseEnter={mouseEnterHandler}
          onMouseLeave={mouseLeaveHandler}
        >
          <ScrollLink
            section="home"
            className="text-[#696c6d] hover:text-primary transition nav-link cursor-pointer"
          >
            Home
          </ScrollLink>
          <ScrollLink
            section="about"
            className="text-[#696c6d] hover:text-primary transition nav-link cursor-pointer"
          >
            About
          </ScrollLink>
          <ScrollLink
            section="portfolio"
            className="text-[#696c6d] hover:text-primary transition nav-link cursor-pointer"
          >
            Portfolio
          </ScrollLink>
          <ScrollLink
            section="testimonials"
            className="text-[#696c6d] hover:text-primary transition nav-link cursor-pointer"
          >
            Reflections
          </ScrollLink>
          <ScrollLink
            section="contact"
            className="text-[#696c6d] hover:text-primary transition nav-link cursor-pointer"
          >
            Contact
          </ScrollLink>
          <RouterLink
            to="/blog"
            className="text-[#696c6d] hover:text-primary transition nav-link cursor-pointer"
          >
            Blog
          </RouterLink>
        </nav>
      </div>

      {/* 🧩 Right: Social Icons with theme toggle */}
      <Socials theme={theme} handleThemeSwitch={handleThemeSwitch} />

      {/* 🧩 Mobile navigation toggle */}
      <MobileNav theme={theme} handleThemeSwitch={handleThemeSwitch} />
    </header>
  );
};

export default Header;
